import PropTypes from 'prop-types'
import Time from 'model/appointments/timeSlots/time'
import Day from 'model/appointments/timeSlots/timeBlock/day'
import { isNil } from 'ramda'
import { TIME_BLOCK } from 'constants/appointments'
import dayjs from 'dayjs'

class TimeBlock extends Time {
  constructor(init) {
    super(init)
    // console.log('> TimeBlock constructor -', init)
    if (isNil(init)) return undefined
    this._days = init.days ? init.days.map(item => new Day(item)) : []
    this.__typename = init.__typename
  }

  static shape = {
    id: PropTypes.string.isRequired,
    days: PropTypes.arrayOf(PropTypes.instanceOf(Day))
  }

  get days() {
    return this._days || []
  }

  get description() {
    return (
      this._description ||
      `${this.activeDaysForDisplay} ${dayjs(this.start_time, 'HH:mm').format(
        'hh:mm A'
      )} - ${dayjs(this.end_time, 'HH:mm').format('hh:mm A')}`
    )
  }

  get display_kind() {
    return this._display_kind || 'Time Block'
  }

  // Calculable
  get toObject() {
    return {
      ...super.toObject,
      days: this.activeDays
    }
  }

  get activeDays() {
    const list = []
    this.days.forEach(day => {
      if (day.getNameIfEnabled) list.push(day.getNameIfEnabled)
    })
    return list
  }

  get activeDaysForDisplay() {
    const list = []
    this.days.forEach(day => {
      if (day.getDisplayNameIfEnabled) list.push(day.getDisplayNameIfEnabled)
    })
    return list.join(', ')
  }

  get isRequested() {
    return (this.__typename || TIME_BLOCK) === TIME_BLOCK
  }

  get isTimeBlock() {
    return (this.__typename || TIME_BLOCK) === TIME_BLOCK
  }
}

export default TimeBlock
